module.exports = __webpack_public_path__ + "img/m_bcpf.63a63f81.png";